const name = 'ThemeType';
export type ThemeCookieTypes = 'light' | 'dark';

export default { name };
